import React, { FC } from 'react';
import { Modal, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { SxProps } from '@mui/system';
import styles from './modalCustom.module.css';
import XLSX from 'xlsx';

interface ModalCustomProps {
	open: boolean;
	handleClose: () => void;
	text: string;
	isExport?: boolean;
	data?: [] | undefined;
}

const style: SxProps = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 450,
	bgcolor: 'background.paper',
	border: '2px solid #000',
	boxShadow: 24,
	p: 4,
	textAlign: 'center',
	padding: '16px',
};

const ModalCustom: FC<ModalCustomProps> = ({ open, handleClose, text, isExport, data }) => {

	const returnDebtsForExport = (data: []) => {
		const workSheet = XLSX.utils.json_to_sheet(data);
		const workBook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workBook, workSheet, 'debts');
		XLSX.writeFile(workBook, 'meters.xlsx');
		handleClose();
	};

	return (
		<div>
			<Modal
				open={open}
				onClose={handleClose}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box sx={style}>
					<Typography
						id="modal-modal-description"
						className={styles.typography}
					>
						{text}
					</Typography>
					{
						isExport
							?
							<div className={styles.button_wrapper}>
								{
									data !== undefined && data.length
										? <button className={styles.button} onClick={() => returnDebtsForExport(data)}>
											Экспорт(excel)
										</button>
										: null
								}

								<button className={styles.button} onClick={() => handleClose()}>
									OK
								</button>
							</div>
							:
							<button className={styles.button} onClick={() => handleClose()}>
								OK
							</button>
					}
				</Box>
			</Modal>
		</div>
	);
};

export default ModalCustom;
